import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as microsoftTeams from "@microsoft/teams-js";
import { getAssignmentSubmission, getMicrosoftAssignmentDetails, getTaskDetails } from 'actions/assignments';
import { setPageTitle } from 'actions/header';
import { getSection } from 'actions/sections';
import { isUserTeacher } from 'helpers/user';
import AssessmentForm from 'containers/Forms/AssessmentForm';
import WopiFrame from 'containers/WopiFrame/WopiFrame';
import { getBlocksByReference } from 'actions/blocks';
import { createAssessments, updateAssessment, getAssignmentAssessment } from 'actions/assessments';
import { Skeleton, Spinner } from 'UI';
import { Icon, Tabs, Tab } from '@haldor/ui';

var SubmissionsView = /*#__PURE__*/function (_Component) {
  _inherits(SubmissionsView, _Component);

  var _super = _createSuper(SubmissionsView);

  function SubmissionsView(props) {
    var _this;

    _classCallCheck(this, SubmissionsView);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var assignmentId = _this.props.match.params.assignmentId;

      _this.props.getMicrosoftAssignmentDetails(assignmentId).then(function () {
        _this.setState({
          loadingDetails: false
        });

        _this.getAssignment();
      });

      if (window.location.hash == '#assessment') {
        _this.setState({
          sidebarWide: true
        });
      }

      window.addEventListener('hashchange', function () {
        _this.setState({
          sidebarWide: window.location.hash == '#assessment'
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAssignment", function () {
      var _this$props$match$par = _this.props.match.params,
          assignmentId = _this$props$match$par.assignmentId,
          submissionId = _this$props$match$par.submissionId;

      if (_this.props.assignment == null) {
        if (_this.isIframe()) {
          microsoftTeams.app.getContext().then(function (context) {
            if (context.team) {
              var group = _this.props.groups.find(function (group) {
                return group.graphId == context.team.groupId;
              });

              if (_this.props.group == null) {
                if (group != null) {
                  _this.props.getSection(group.id);
                }
              }
            }

            _this.props.getTaskDetails(assignmentId, context.team.groupId).then(function () {
              _this.props.setPageTitle(_this.props.assignment.displayName);

              if (!context.team) {
                var _group = _this.props.groups.find(function (group) {
                  return group.graphId == _this.props.assignment.classId;
                });

                if (_group != null) {
                  _this.props.getSection(_group.id);
                }
              }

              if (_this.props.blocks == null && _this.props.details != null) {
                _this.props.getBlocksByReference(_this.props.details.id, 'ASSIGNMENT');
              }

              _this.props.getAssignmentAssessment(_this.props.details.id);

              _this.setState({
                loadingAssignment: false
              });
            });
          });
        } else {
          _this.props.getTaskDetails(assignmentId).then(function () {
            _this.props.setPageTitle(_this.props.assignment.displayName);

            _this.setState({
              loadingAssignment: false
            });

            if (_this.props.group == null) {
              var group = _this.props.groups.find(function (group) {
                return group.graphId == _this.props.assignment.classId;
              });

              if (group != null) {
                _this.props.getSection(group.id);
              }
            }

            if (_this.props.blocks == null && _this.props.details != null) {
              _this.props.getBlocksByReference(_this.props.details.id, 'ASSIGNMENT');
            }

            _this.props.getAssignmentAssessment(_this.props.details.id);
          });
        }
      } else {
        _this.props.setPageTitle(_this.props.assignment.displayName);

        if (_this.props.blocks == null && _this.props.details != null) {
          _this.props.getBlocksByReference(_this.props.details.id, 'ASSIGNMENT');

          _this.props.getAssignmentAssessment(_this.props.details.id);
        }

        _this.setState({
          loadingAssignment: false
        });
      }

      if (_this.state.activeSubmission == null && submissionId != null) {
        var submission = {
          'id': submissionId
        };

        _this.onSubmissionSelect(submission);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var details = nextProps.details;

      if (_this.props.match.params.submissionId != nextProps.match.params.submissionId) {
        var submission = {
          'id': nextProps.match.params.submissionId
        };

        _this.onSubmissionSelect(submission);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSidebar", function () {
      _this.setState({
        sidebar: !_this.state.sidebar
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filterStudentList", function () {
      var _this$props = _this.props,
          group = _this$props.group,
          assignment = _this$props.assignment;
      var students = [];

      if (assignment == null) {
        return students;
      }

      if (assignment.submissions != null && assignment.submissions.length > 0) {
        if (group != null && isUserTeacher(_this.props.currentUser)) {
          group.students.forEach(function (groupStudent) {
            var student = assignment.submissions.find(function (submission) {
              return submission.recipient.userId == groupStudent.id;
            });

            if (student != null) {
              students.push(groupStudent);
            }
          });
        }

        return students;
      }

      if (assignment.assignTo == null || assignment.assignTo.recipients == null) {
        return students;
      }

      if (group != null && isUserTeacher(_this.props.currentUser)) {
        group.students.forEach(function (groupStudent) {
          if (_this.props.assignment.assignTo == null || _this.props.assignment.assignTo.recipients == null) {
            return;
          }

          var student = _this.props.assignment.assignTo.recipients.find(function (assignmentStudentId) {
            return assignmentStudentId == groupStudent.id;
          });

          if (student != null) {
            students.push(groupStudent);
          }
        });
      }

      return students;
    });

    _defineProperty(_assertThisInitialized(_this), "getItems", function () {
      var activeSubmission = _this.state.activeSubmission;
      var assignment = _this.props.assignment;

      var students = _this.filterStudentList();

      var items = [];

      if (activeSubmission != null && assignment != null) {
        var task = assignment.submissions.find(function (sub) {
          return sub.id == activeSubmission;
        });
        var student = students.find(function (student) {
          return student.id == task.recipient.userId;
        });

        if (student != null) {
          var newItem = {
            students: [student],
            id: student.id,
            selected: true,
            status: task.status
          };
          items.push(newItem);
        }
      }

      return items;
    });

    _defineProperty(_assertThisInitialized(_this), "onDocumentClick", function (file) {
      _this.setState({
        activeFile: file
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderUserAssignmentAttachedDocument", function () {
      var submission = _this.props.submission;
      var isTeacher = isUserTeacher(_this.props.currentUser);
      return submission.map(function (file) {
        var notOfficeFile = file.webUrlViewMode === '';
        var active = _this.state.activeFile != null ? _this.state.activeFile.id == file.id : false;
        return /*#__PURE__*/React.createElement("div", {
          className: 'document' + (active ? ' selected' : ''),
          key: file.id,
          onClick: function onClick(e) {
            return _this.onDocumentClick(file);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "title"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "File"
        }), file.name), /*#__PURE__*/React.createElement("div", {
          className: "action"
        }, (!_this.props.IsSubmitted || isTeacher) && !notOfficeFile ? /*#__PURE__*/React.createElement("a", {
          href: file.webUrlEditMode,
          target: "_blank"
        }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
          name: "Pen_Small"
        })), _this.props.translate('Edit')) : null, isTeacher ? null : !_this.props.IsSubmitted ? /*#__PURE__*/React.createElement(Link, {
          onClick: function onClick() {
            _this.removeDocument(file.name);
          }
        }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
          name: "Bin"
        })), _this.props.translate('Remove')) : null), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderNoDocuments", function () {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement("strong", null, _this.props.translate('no-files-found')));
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmissionSelect", function (submission) {
      var _this$props2 = _this.props,
          assignment = _this$props2.assignment,
          details = _this$props2.details;

      if (submission == null) {
        return;
      }

      var student = null;
      var foundSubmission = null;

      if (assignment != null) {
        var students = _this.filterStudentList();

        foundSubmission = assignment.submissions.find(function (sub) {
          return sub.id == submission.id;
        });
        student = students.find(function (student) {
          return student.id == foundSubmission.recipient.userId;
        });
      }

      if (details != null) {
        _this.setState({
          activeSubmission: submission.id,
          loadingSubmission: true
        });

        _this.props.getAssignmentSubmission(details.id, submission.id).then(function () {
          _this.setState({
            loadingSubmission: false
          });

          var submission = _this.props.submission;

          if (submission != null && submission.length > 0) {
            // Select the first document
            _this.onDocumentClick(submission[0]);

            return;
          }

          _this.setState({
            activeFile: null
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getActiveStudent", function (student) {
      if (student) {
        return student.firstName + " " + student.lastName;
      }

      return /*#__PURE__*/React.createElement(Skeleton, null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderListView", function () {
      var _this$props3 = _this.props,
          assignment = _this$props3.assignment,
          details = _this$props3.details;
      var activeSubmission = _this.state.activeSubmission;
      if (assignment == null && assignment.submissions != null || details == null || activeSubmission == null) return null;

      var students = _this.filterStudentList().sort(function (a, b) {
        return a.lastName.localeCompare(b.lastName);
      });

      var active = assignment.submissions.find(function (submission) {
        return submission.id == activeSubmission;
      });
      var studentId = students.findIndex(function (student) {
        var _active$recipient;

        return student.id == (active === null || active === void 0 ? void 0 : (_active$recipient = active.recipient) === null || _active$recipient === void 0 ? void 0 : _active$recipient.userId);
      });
      var nextStudentIndex = studentId + 1;
      var prevStudentIndex = studentId - 1;
      var prevStudent = prevStudentIndex >= 0 ? students[prevStudentIndex] : null;
      var nextStudent = nextStudentIndex < students.length ? students[nextStudentIndex] : null;
      var next = nextStudent !== null ? assignment.submissions.find(function (x) {
        return x.recipient.userId === (nextStudent === null || nextStudent === void 0 ? void 0 : nextStudent.id);
      }) : null;
      var prev = prevStudent !== null ? assignment.submissions.find(function (x) {
        return x.recipient.userId === (prevStudent === null || prevStudent === void 0 ? void 0 : prevStudent.id);
      }) : null;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '0.75rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement(Link, {
        to: "#",
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _this.onSubmissionSelect(prev);
        }
      }, _this.toggleIcon(false)), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          display: 'flex',
          textAlign: 'center',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 500,
          flex: '1'
        }
      }, _this.getActiveStudent(students[studentId]))), /*#__PURE__*/React.createElement(Link, {
        to: "#",
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _this.onSubmissionSelect(next);
        }
      }, _this.toggleIcon(true))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFile", function (file) {
      if (file == null) return null;
      var notOfficeFile = file.webUrlViewMode === '';
      var mp4File = notOfficeFile && /.mp4$/.test(file.webUrl);
      var imageFile = notOfficeFile && /(.png|.jpg|.gif|.jpeg)$/.test(file.webUrl);
      var m4aFile = notOfficeFile && /.m4a$/.test(file.webUrl);

      if (!notOfficeFile) {
        return /*#__PURE__*/React.createElement(WopiFrame, {
          activeFile: file.webUrlViewMode
        });
      } else if (mp4File) {
        return /*#__PURE__*/React.createElement("video", {
          src: file.webUrl,
          controls: true,
          autoPlay: true,
          width: "100%",
          height: "600"
        }, "Your browser does not support the video tag.");
      } else if (imageFile) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            height: '600px',
            width: '100%',
            overflowX: 'scroll'
          }
        }, /*#__PURE__*/React.createElement("img", {
          src: file.webUrl,
          width: "100%"
        }));
      } else if (m4aFile) {
        return /*#__PURE__*/React.createElement("audio", {
          controls: true,
          preload: "auto",
          autoPlay: true,
          style: {
            width: '100%'
          }
        }, /*#__PURE__*/React.createElement("source", {
          src: file.webUrl,
          type: "audio/mp4"
        }), /*#__PURE__*/React.createElement("p", null, "Your browser does not support the audio tag."));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderView", function () {
      var activeFile = _this.state.activeFile;
      return /*#__PURE__*/React.createElement("div", null, activeFile != null ? _this.renderFile(activeFile) : /*#__PURE__*/React.createElement("div", null));
    });

    _defineProperty(_assertThisInitialized(_this), "onAssessmentSubmit", function (values) {
      return new Promise(function (resolve) {
        var assignment = _this.props.assignment;
        var active = assignment.submissions.find(function (submission) {
          return submission.id == _this.state.activeSubmission;
        });

        if (values.id != null) {
          var existing = _this.props.assessments.find(function (assessment) {
            return assessment.id == values.id;
          });

          _this.props.updateAssessment(values, existing).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this.props.getAssignmentAssessment(_this.props.details.id);

                  case 2:
                    resolve(1);

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })));

          return true;
        }

        var data = _objectSpread(_objectSpread({}, values), {}, {
          externalId: _this.props.assignment.id,
          studentId: active.recipient.userId
        });

        _this.props.createAssessments([data]).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this.props.getAssignmentAssessment(_this.props.details.id);

                case 2:
                  resolve(1);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })));
      });
    });

    _this.state = {
      loadingSubmission: true,
      loadingAssignment: true,
      loadingDetails: false,
      activeFile: null,
      activeSubmission: null,
      sidebarWide: false,
      sidebar: true
    };
    return _this;
  }

  _createClass(SubmissionsView, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "toggleIcon",
    value: function toggleIcon(flip) {
      return /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        className: flip ? 'i-90' : 'a-90',
        style: {
          height: '7px',
          width: '15px'
        }
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          assignmentAttachementLoading = _this$state.assignmentAttachementLoading,
          loadingSubmission = _this$state.loadingSubmission,
          activeSubmission = _this$state.activeSubmission,
          loadingDetails = _this$state.loadingDetails,
          sidebarWide = _this$state.sidebarWide;
      var _this$props4 = this.props,
          details = _this$props4.details,
          assignment = _this$props4.assignment,
          submission = _this$props4.submission;
      var isTeacher = isUserTeacher(this.props.currentUser);
      var items = this.getItems();
      var assessmentBlocks = [];
      var assessment = [];

      if (assignment == null) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      if (this.props.blocks != null) {
        assessmentBlocks = _toConsumableArray(this.props.blocks).filter(function (block) {
          return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
        });
      }

      if (this.props.assessments != null && activeSubmission != null) {
        var active = assignment.submissions.find(function (submission) {
          return submission.id == activeSubmission;
        });
        assessment = this.props.assessments.find(function (assessment) {
          return assessment.studentId == active.recipient.userId;
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: sidebarWide ? "attached-user-documents wide" : "attached-user-documents"
      }, /*#__PURE__*/React.createElement("div", {
        className: "iframe-section left-side"
      }, this.renderView()), this.state.sidebar ? /*#__PURE__*/React.createElement("div", {
        className: "sidebar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "collapse color--meta",
        onClick: this.toggleSidebar
      }, this.props.translate('fold-up'), " ", /*#__PURE__*/React.createElement(Icon, {
        name: "ArrowRight"
      })), isTeacher ? this.renderListView() : null, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('details'),
        route: "details"
      }, loadingSubmission || loadingDetails ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : submission.length < 1 ? this.renderNoDocuments() : this.renderUserAssignmentAttachedDocument()), /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('Assessment'),
        route: "assessment"
      }, isTeacher && loadingSubmission || loadingDetails ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : isTeacher && items.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AssessmentForm, {
        onSubmit: this.onAssessmentSubmit,
        items: [this.props.assignmentTask],
        blocks: assessmentBlocks,
        initialValues: assessment,
        referenceType: "TeamsAssignment",
        referenceId: details.id,
        showStudents: false
      })) : null))) : /*#__PURE__*/React.createElement("div", {
        className: "expand color--meta",
        onClick: this.toggleSidebar
      }, this.props.translate('fold-out'), " ", /*#__PURE__*/React.createElement(Icon, {
        name: "ArrowLeft"
      })));
    }
  }]);

  return SubmissionsView;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    details: state.assignments.teamsAssignmentDetails,
    assignment: state.assignments.active_assignment,
    assessments: state.assessments.assessments,
    submission: state.assignments.submission,
    group: state.sections.activeSection,
    groups: state.sections.educationGroups,
    blocks: state.Blocks.reference
  };
}

export default connect(mapStateToProps, {
  getAssignmentSubmission: getAssignmentSubmission,
  getTaskDetails: getTaskDetails,
  getMicrosoftAssignmentDetails: getMicrosoftAssignmentDetails,
  getAssignmentAssessment: getAssignmentAssessment,
  getSection: getSection,
  setPageTitle: setPageTitle,
  getBlocksByReference: getBlocksByReference,
  updateAssessment: updateAssessment,
  createAssessments: createAssessments
})(SubmissionsView);